import CrudPage from '@modules/cruds/CrudPage';
import OrganizationAclForm from './OrganizationAclForm';
import * as yup from 'yup';
import { defaultConfigComponent } from './RoleAssignment';

const organizationAclPageSchema = yup.object().shape({
  roleId: yup.string().required().label('Role'),
  userId: yup.string().required().label('User'),
});

const OrganizationAclPage = props => {
  const defaultValues = {};

  return (
    <CrudPage
      key={'organizationAclPage'}
      configComponent={defaultConfigComponent}
      form={OrganizationAclForm}
      defaultValues={defaultValues}
      validationSchema={organizationAclPageSchema}
    />
  );
};

export default OrganizationAclPage;
